import {
	uploadFileConstants
}from "./constants"
import api from './api'
import {
	defAction
}from "../../helpers/defaultAction"
import {
	request, success, failure
}from '../../helpers/dispatchFunctions'

export const uploadFileAction = {
	uploadFiles,
	chooseFile,
	chooseFiles,
	removeFile,
	clearFiels,
	deleteFiels,
	deleteAppealOrgFile,
	deleteResolutionFile
}

function uploadFiles(){
	return (dispatch, getState) => {
		dispatch(request(uploadFileConstants.UploadFiles.REQUEST))
		const fd = new FormData()
		getState().fileReducer.chosenFiles.forEach((file) => {
			fd.append("Files", file, file.name)
		})

		/* здесь берутся файлы из стора: getState().fileReducer.chosenFiles
		   желательно использовать те же константы, что и здесь я использовал */
		api.uploadFiles(fd).then(res => {
			dispatch(success(uploadFileConstants.UploadFiles.SUCCESS))
		})
			.catch(err => {
				dispatch(failure(uploadFileConstants.UploadFiles.FAILURE, { err }))
			})
	}
}

function chooseFile(file){
	return dispatch => {
		dispatch({
			type    : uploadFileConstants.CHOOSE_FILE,
			payload : file
		})
	}
}

function chooseFiles(fileList){
	return dispatch => {
		dispatch({
			type    : uploadFileConstants.CHOOSE_FILES,
			payload : fileList
		})
	}
}

function removeFile(file){
	return dispatch => {
		dispatch({
			type    : uploadFileConstants.REMOVE_FILE,
			payload : file
		})
	}
}

function clearFiels(){
	return (dispatch) => dispatch({
		type: uploadFileConstants.CLEAR_FILES
	})
}

function deleteFiels(params){
	const dispatchObj = {
		constants : uploadFileConstants.DeleteFiels,
		service   : {
			func   : api.deleteFiels,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function deleteAppealOrgFile(params){
	const dispatchObj = {
		constants : uploadFileConstants.DeleteAppealOrgFile,
		service   : {
			func   : api.deleteAppealOrgFile,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function deleteResolutionFile(params){
	const dispatchObj = {
		constants : uploadFileConstants.DeleteResolutionFile,
		service   : {
			func   : api.deleteResolutionFile,
			params : params
		}
	}
	return defAction(dispatchObj)
}